import React from 'react';
import PropTypes from 'prop-types';

import Checkmark from '../../../../common/img/components/Checkmark';

import styles from './EventListingsPriceBox.module.scss';

const EventListingsPriceBox = ({ site }) => {
  const { eventListingPriceInDollars } = window.eventListings;
  const features = [
    'Ability to drive traffic directly to your Event info page',
    'A minimum of 3X placements in our newsletters',
    (
      <>
        Placement in the{' '}
        <a href="/events" target="_blank" rel="noopener noreferrer">Events Feed</a>
        {' '}on {site.name} until day after event
      </>
    ),
    (
      <>
        Displayed on{' '}
        <a href="/" target="_blank" rel="noopener noreferrer">{site.name}'s Homepage</a>
        {' '}in Events Sidebar until day after event
      </>
    ),
  ];
  return (
    <aside className={styles.priceBox} aria-labelledby="priceBox__heading">
      <p className={styles.priceBox__header}>
        <span className={styles.priceBox__price}>${eventListingPriceInDollars}</span>
        <span className={styles.priceBox__quantifier}>/ event promotion</span>
      </p>
      <p className={styles.priceBox__description}>
        What's included:
      </p>
      <ul className={styles.priceBox__features}>
        {features.map((feature, index) => (
          <li key={index}>  {/* eslint-disable-line react/no-array-index-key */}
            <Checkmark /> <span>{feature}</span>
          </li>
        ))}
      </ul>
    </aside>
  );
};

EventListingsPriceBox.propTypes = {
  site: PropTypes.shape({
    name: PropTypes.string,
    unique_monthly_visitors: PropTypes.string,
  }).isRequired,
};

export default EventListingsPriceBox;
